import React from 'react'
import Typography from "material-ui/Typography";
import Grid from "material-ui/Grid";
import { withStyles } from 'material-ui/styles'
import styles from '../../../../summaryv2/styles'
import { dateLongMonthFormatter, dateTimeFormatter } from "../../../../../../../../common/utils";

class FiberHeader extends React.Component {
  constructor(props) {
    super(props)
  }

  getAdapterName = (adapter, translate) => {
    if (adapter === "MM Fibre") {
      adapter = "MM " + translate("fiber");
    }
    else if (adapter === "SM Fibre") {
      adapter = "SM " + translate("fiber");
    }
    return adapter;
  }

  render() {
    const {
      classes,
      results,
      translate,
      fiberLengthData,
    } = this.props

    let maintestadapter = "-";
    let remotetestadapter = "-";
    let setreftime = null;
    if (results && results.data) {
      maintestadapter = this.getAdapterName(results.data.maintestadapter, translate);
      remotetestadapter = this.getAdapterName(results.data.remotetestadapter, translate);

      if (results.data.setreference && results.data.setreference.setreftime) {
        setreftime = dateTimeFormatter(results.data.setreference.setreftime)
      }
    }    

    return (
    <Grid container className={classes.resultsViewer}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container className={classes.cometTestInfo}>
          <Grid item xs>
            <span>
              <Typography type="subheading" className={classes.testDetails}>
                <strong>{translate("job_engineer")}</strong>:
                {results.data.engineer}
              </Typography>
              <Typography type="subheading" className={classes.testDetails}>
                <strong>{translate("job_test_adapters")}</strong>:
              </Typography>
              <Typography type="subheading" className={classes.testDetails}>
                {translate("result_main")}: {maintestadapter}
              </Typography>
              {results && results.data && results.data.isloop === false && (
              <Typography type="subheading" className={classes.testDetails}>
              {translate("result_remote")}: {remotetestadapter}
              </Typography>)}
            </span>
          </Grid>
          <Grid item xs md={3}>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("job_device")}</strong>:
              {results.data.device}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("calibration_date")}</strong>:
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              {dateLongMonthFormatter(results.data.calibrationdate)}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("fiber_setreference_time")}</strong>: {setreftime}
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("job_standard")}</strong>:
              {results.data.teststandard
                ? results.data.teststandard
                : results.data.standard
                ? results.data.standard
                : ""}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("general_limit")}</strong>:
              {results.data.testlimit}
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("job_link_model")}</strong>:
              {translate("general_na").toUpperCase()}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("fiber_reference")}</strong>:
              {results.data.jumper}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              {dateTimeFormatter(results.data.testtime)}
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("job_cable_type")}</strong>:
              {results.data.testedcabletype}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              <strong>{translate("cable_brand")}</strong>:
              {results.data.cablebrand}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              {results.data.cablename}
            </Typography>
            <Typography type="subheading" className={classes.testDetails}>
              Type:{results.data.cableshield}&nbsp;&nbsp;&nbsp;&nbsp;RI:{fiberLengthData.refractiveindex}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
    );
  }
}

export default withStyles(styles)(FiberHeader)

